import { History, Redo2, Undo2 } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "../ui/button";
import { cn } from "../../lib/utils";
import { useHistoryStore } from "../../stores/history-store";
import { nextRedo, nextUndo } from "../../lib/schedule-history/app-history-actions";

type HistoryControlsProps = { scheduleOnly?: boolean };

export function HistoryControls({ scheduleOnly = false }: HistoryControlsProps) {
  const { t } = useTranslation();
  const scope = scheduleOnly ? "schedule" : undefined;
  const undoAction = useHistoryStore(state => nextUndo(state.events, state.undoneIds, scope));
  const redoAction = useHistoryStore(state => nextRedo(state.events, state.undoneIds, scope));
  const panelOpen = useHistoryStore(state => state.panelOpen);
  const undo = useHistoryStore(state => state.undo);
  const redo = useHistoryStore(state => state.redo);
  const togglePanel = useHistoryStore(state => state.togglePanel);
  const undoLabel = t(scheduleOnly ? "history.undoSchedule" : "history.undo");
  const redoLabel = t(scheduleOnly ? "history.redoSchedule" : "history.redo");

  return (
    <div role="group" aria-label={t("history.title")} className="flex items-center gap-1">
      <Button variant="ghost" size="icon-sm" disabled={!undoAction} onClick={() => undo(scope)}
        aria-label={undoLabel} title={undoLabel}>
        <Undo2 />
      </Button>
      <Button variant="ghost" size="icon-sm" disabled={!redoAction} onClick={() => redo(scope)}
        aria-label={redoLabel} title={redoLabel}>
        <Redo2 />
      </Button>
      {!scheduleOnly && <Button variant="ghost" size="icon-sm" onClick={togglePanel}
        aria-label={t(panelOpen ? "history.hide" : "history.show")}
        title={t(panelOpen ? "history.hide" : "history.show")}
        aria-expanded={panelOpen} aria-controls="history-panel"
        className={cn(panelOpen && "bg-neutral-900 text-white hover:bg-neutral-800 hover:text-white")}>
        <History />
      </Button>}
    </div>
  );
}
